/**
 * The time since javascript was enabled.
 * @returns
 */
export function getDurationSinceJSEnabled(): number {
    if (typeof window === 'undefined') return Date.now();
    return Date.now() - (window as any).JS_INIT_TIME;
}
